import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[560px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20fashion%20accessories%20floating%20and%20suspended%20in%20air%20on%20dreamy%20soft%20pastel%20pink%20gradient%20backdrop%20with%20ethereal%20bokeh%20light%20particles%20artistic%20surreal%20editorial%20photography%20with%20airy%20cloud%20like%20atmosphere%20whimsical%20and%20elegant%20soft%20focus%20dreamscape&width=1800&height=800&seq=kakobuy-cta-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet lifestyle"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-20">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col items-start max-w-2xl">
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-none lowercase mb-8">
              ready to find
              <br />
              your next
              <br />
              favorite item?
            </h2>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md mb-8">
              Thousands of products are discovered every month through the Kakobuy Spreadsheet. Do not miss out on the best finds — visit the main website and start exploring curated product collections today.
            </p>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 bg-white text-foreground-900 px-8 py-4 rounded-full text-sm font-semibold hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
            >
              Visit Kaspreadsheet
              <span className="w-7 h-7 flex items-center justify-center bg-foreground-900 text-white rounded-full">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}